import React from 'react';

import { Header } from 'components/Header';
import { HeaderFilters } from 'components/HeaderFilters';

import { StyledPage, StyledChildren } from './styled';

export const HeaderFiltersPage = ({
  children,
  monitoringPage,
  noMargin = false,
  isSubMenuOpen = false,
  defaultOpen = null,
}) => {
  const headerFiltersRef = React.createRef(null);
  return (
    <StyledPage noMargin={noMargin} monitoringPage={monitoringPage} isSubMenuOpen={isSubMenuOpen}>
      <Header>
        <HeaderFilters ref={headerFiltersRef} defaultOpen={defaultOpen} />
      </Header>
      <StyledChildren monitoringPage={monitoringPage}>{children}</StyledChildren>
    </StyledPage>
  );
};
